module.exports = __webpack_public_path__ + "img/destin_entrecroise.1cfffebd.jpg";